/**
 * Vehicle Name
 */
import React from 'react';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { lookupsState } from '../redux/lookupsSlice';

const useStyles = makeStyles(() => ({
  evidence: {
    fontSize: '1.4em',
    lineHeight: '1.3em',
    fontWeight: 'bold',
  },
}));

function VehicleName() {
  const classes = useStyles();
  const { configuration } = useSelector(lookupsState);
  const {
    make, model, version,
  } = configuration.vehicle || {};
  return (
    <div className="ga-ecommerce-vehicle-name" style={{ marginBottom: 10 }}>
      <span className={`${classes.evidence} ga-ecommerce-vehicle-name-make`}>{`${make} ${model}`}</span>
      { version
        && (
          <>
            <br />
            <span className="ga-ecommerce-vehicle-name-version">{version}</span>
          </>
        )}
    </div>
  );
}

export default VehicleName;
